<template>
  <div>
    <span v-if="row[prop]" v-html="row[prop]"></span>
    <span v-else class="warn"><i class="el-icon-warning"></i></span>
  </div>
</template>

<script>
export default {
  name: 'OrderTotal',
  components: { },
  props: {
    row: {
      type: Object,
      required: true
    },
    prop: {
      type: String,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style lang="stylus" scoped>
.warn {
  color: #f39d61;
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/data_overview/common/OrderTotal.vue